<template>
  <div>
    <page-header
      icon="mdi-file-chart-outline"
      :title="$t('routes.report')"
      :subtitle="$t('manage_meal_reports')"
    >
      <template #actions>
        <v-row no-gutters justify="end">
          <excel-button @click="setExcel" class="mr-2" />
          <print-button @click="setPrinter" />
        </v-row>
      </template>
    </page-header>

    <!-- Multi Restaurant Report -->
    <company-multi-restaurant-report v-if="isMultiRestaurantCompany" />

    <!-- Default Report -->
    <company-default-report v-else />
  </div>
</template>

<script>
import CompanyDefaultReport from "@/components/company/reports/CompanyDefaultReport.vue";
import CompanyMultiRestaurantReport from "@/components/company/reports/CompanyMultiRestaurantReport.vue";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "CompanyReportPage",
  mixins: [hasPrinting, hasExcel],
  components: {
    CompanyDefaultReport,
    CompanyMultiRestaurantReport,
  },
  computed: {
    isMultiRestaurantCompany() {
      return this.$store.state.company?.contract === 4;
    },
  },
};
</script>
